export enum OriginBlockFormValueKey {
  Title = 'title',
  Link = 'link',
  Description = 'description',
  ContactsType = 'contactsType',
  HasBottomBorder = 'hasBottomBorder',
}
